module.exports = __webpack_public_path__ + "assets/img/229ed1f0e1e0dd51e3b06c4cdfb4be57.svg";